/* istanbul ignore file */
export const Analytics =  {
    trackPageView: () => {
        window.fbq('track', 'Pageview');
    },
    trackInitiateCheckout : () => {
        window.fbq('track', 'InitiateCheckout');
        window.gtag('event', 'begin_checkout');
    },
    trackPurchase: (amount) => {
        const am = amount.replace("+iva", "");
        window.fbq('track', 'Purchase', {currency: "EUR", value: am});
        window.gtag('event', 'purchase', {value: am});
    }
}